import { render, staticRenderFns } from "./DashboardViewResolver.vue?vue&type=template&id=b76d7e48&"
import script from "./DashboardViewResolver.vue?vue&type=script&lang=js&"
export * from "./DashboardViewResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports